<template>
    <div class="kgk-company-search">
        <div v-show="!showNewForm">
            <div class="kgk-form-row">
                <div class="kgk-input-group">
                    <div class="kgk-input-group-prepend">
                        <i v-if="loading" class="fas fa-spinner fa-spin fa-fw"></i>
                        <i v-else class="fas fa-search fa-fw"></i>
                    </div>
                    <input type="text" placeholder="Firmen durchsuchen ..." v-model="search">
                </div>
            </div>
            <table v-if="results && results.length > 0" style="width: 100%;">
                <tbody>
                    <tr v-for="record in results" :key="record.identifier">
                        <td style="vertical-align:middle; text-align:left;">
                            <b v-if="record.selected">{{ record.name }}</b>
                            <span v-else>{{ record.name }}</span><br>
                            <span><i class="fas fa-map-marker-alt"></i> <i>{{ record.street }} {{ record.street_number }}, {{ record.zip }} {{ record.city }}</i></span>
                        </td>
                        <td class="text-right" style="vertical-align:middle;">
                            <button type="button" @click.prevent="selectRecord(record)">
                                <span v-if="record.selected"><i class="fas fa-check"></i> ausgewählt</span>
                                <span v-else>auswählen</span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p v-if="search.length >= 3 && results.length == 0 && !loading">Keine Ergebnisse</p>
            <p v-else-if="search.length > 0 && search.length < 3">Bitte geben Sie mindestens 3 Zeichen ein.</p><!-- @TODO: min input length magic number -->
            <div v-if="searched" style="margin-top:24px;margin-bottom:32px;">
                <div style="margin-bottom:10px;">Firma nicht aufgeführt?</div>
                <button type="button" @click.prevent="showNewForm = true"><span class="button-text"><i class="fas fa-plus"></i> Neue Firma anlegen</span></button>
            </div>
        </div>
        <div v-show="showNewForm">
            <form @submit.prevent="() => {}">
                <div class="kgk-form-row">
                    Firmenname
                    <div class="kgk-input-group">
                        <input type="text" required v-model="newCompanyForm.name" name="name">
                    </div>
                    <!--<div v-if="showValidationErrors && !prenameRequiredValidation" class="kgk-form-validation-error-inline">Du musst einen Vornamen angeben.</div>-->
                </div>
                <div class="kgk-form-row register-input-row-7">
                    Straße & Hausnummer
                    <div class="kgk-input-group">
                        <input type="text" required v-model="newCompanyForm.street" name="street">
                        <input type="text" required v-model="newCompanyForm.street_number" style="width:20%;" name="street_number">
                    </div>
                </div>
                <div class="kgk-form-row register-input-row-8">
                    PLZ & Stadt
                    <div class="kgk-input-group">
                        <input type="number" required v-model="newCompanyForm.zip" style="width:20%;" name="zip">
                        <input type="text" required v-model="newCompanyForm.city" name="city">
                    </div>
                </div>
                <div v-if="newCompanyErrorFill" class="kgk-form-validation-error-inline" style="margin-bottom:20px;">Bitte füllen Sie alle Felder aus.</div>
            </form>
            <a href="#" @click.prevent="showNewForm = false">&laquo; zurück zur Suche</a>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import company from '../../api/company';

    export default {
        name: 'CompanySearch',
        components: {

        },
        props: {
            //excludeTeam: String
            multiple: {
                type: Boolean,
                required: false,
                default: true,
            },
            currentCompany: {
                type: Object,
                required: false,
                default: null,
            },
        },
        data() {
            return {
                loading: false,
                searched: false,
                search: '',
                searchTimeout: null,
                searchRequest: null,
                searchCancel: null,
                searchDebounceTime: 400,
                results: [],
                showNewForm: false,
                newCompanyForm: {
                    name: '',
                    street: '',
                    street_number: '',
                    zip: '',
                    city: '',
                },
                newCompanyErrorFill: false,
            }
        },
        computed: {
            selectedRecords: function() {
                return this.results.filter(record => record.selected);
            },
        },
        watch: {
            showNewForm(newVal) {
                // make sure parent gets updated when we change modes
                if( newVal ) {
                    //this.$emit('createChanged', this.newCompanyForm);
                    this.newCompanyForm.name = this.newCompanyForm.name + ''; // force re-run of newCompanyForm watcher
                }
                else {
                    this.$emit('selected', this.selectedRecords);
                }
            },
            selectedRecords(newVal) {
                this.$emit('selected', newVal);
            },
            newCompanyForm: {
                deep: true,
                handler(newVal) {
                    console.log('newCompanyForm changed', JSON.stringify(newVal));

                    if( newVal.name.trim().length < 1 || newVal.street.trim().length < 1 || newVal.street_number.trim().length < 1 || newVal.zip.trim().length < 1 || newVal.city.trim().length < 1 ) { // some error
                        newVal = null;
                        this.newCompanyErrorFill = true;
                    }
                    else {
                        this.newCompanyErrorFill = false;
                    }

                    this.$emit('createChanged', newVal);
                },
            },
            search() {
                if( this.timeout ) {
                    clearTimeout(this.searchTimeout);
                }
                this.searchTimeout = setTimeout(this.refresh, this.searchDebounceTime);

                if( this.search.length >= 3 ) { // @TODO: min input length magic number
                    this.loading = true;
                }
                else {
                    this.searched = false;
                }
            }
        },
        methods: {
            selectRecord(record) {
                if( !this.multiple && !record.selected ) {
                    this.results.forEach(record => {
                        record.selected = false;
                    });
                }
                record.selected = !record.selected;
            },
            refresh() {
                if( this.searchCancel ) { // not really needed
                    this.searchCancel.cancel();
                    this.loading = false;
                }
                //this.searchCancel.cancel('Outdated');

                if( this.search.length < 3 ) { // @TODO: min input length magic number
                    return;
                }

                this.searchCancel = axios.CancelToken.source();

                this.loading = true;

                company.search(
                    this,
                    this.search,
                    this.searchCancel.token,
                    (data) => {
                        this.searched = true;
                        console.log('finished');
                        this.loading = false;
                        this.results = data.companies.map(function(user) {
                            user.selected = false;
                            return user;
                        });
                    },
                    (e) => {
                        if( axios.isCancel(e) ) {
                            return;
                        }

                        this.loading = false;
                    },
                    () => {
                        //if( !this.searchTimeout ) {

                        //}
                    },
                );
            },

        },
        mounted() {
            if( this.currentCompany ) {
                this.newCompanyForm.name = this.currentCompany.name;
                this.newCompanyForm.street = this.currentCompany.street;
                this.newCompanyForm.street_number = this.currentCompany.street_number;
                this.newCompanyForm.zip = this.currentCompany.zip;
                this.newCompanyForm.city = this.currentCompany.city;
                this.showNewForm = true;
            }
        }
    }
</script>
